export interface Property {
  // Identificadores
  id: string;
  codigo_inmueble: string;
  prointegral?: string;  // Código de Prointegral (columna C - "PR pro integral")
  metro_cuadrado: string;
  espacio_urbano?: string;
  finca_raiz?: string;
  cien_cuadras?: string;
  proppit?: string;

  // Información de la agencia
  sede: string;
  asesor: string;

  // Características del inmueble
  tipo_inmueble?: 'Apto' | 'Casa' | 'Local' | 'Oficina' | 'Bodega' | 'Lote' | 'Consultorio' | 'Casa Comercial';
  amoblado?: 'Vacio' | 'Amoblado';
  direccion: string;
  ciudad: string;
  sector: string;
  sub_sector?: string;
  edificio?: string;
  edad_edificio?: number;

  // Información comercial
  inversion?: string;
  transaccion?: 'Arriendo' | 'Venta' | 'Ambos';
  precio: number;
  valor_venta?: number;
  valor_arriendo?: number;
  administracion?: number;
  predial?: number;

  // Características físicas
  niveles?: number;
  habitaciones?: number;
  banos?: number;
  parqueaderos: number;
  util?: string;
  area_construida?: number;
  area_total?: number;
  area_privada?: number;
  estrato: number;

  // Servicios y amenidades
  servicios?: string;
  balcon?: boolean;
  piscina?: boolean;
  zonas_comunes?: string;
  ascensor?: boolean;

  // Estado y disponibilidad
  llaves?: string;
  estado: 'Disponible' | 'No Disponible' | 'Arrendado' | 'Vendido';

  // Información del propietario (solo para usuarios autorizados)
  nombre_propietario?: string;
  nombre_propietario_2?: string;
  telefono_1?: string;
  telefono_2?: string;
  celular_1?: string;
  celular_2?: string;
  celular_3?: string;
  email?: string;
  
  // Campos adicionales para el frontend
  descripcion?: string;
  telefono_propietario?: string;
  email_propietario?: string;
  observaciones?: string;
  avatar?: string;

  // Metadatos temporales - IMPORTANTE para filtros de fecha
  fecha_creacion?: string;
  ultima_actualizacion?: string;
  mes_captacion?: string; // Ej: "Enero*2025", "Febrero*2025"
  fecha_captacion?: string; // Fecha específica de captación
  fecha_modificacion?: string; // Última fecha de modificación
  captado_por?: string; // Usuario que captó la propiedad
  
  // Ubicación
  latitud?: number;
  longitud?: number;
  
  // Multimedia y comisiones
  imagenes?: string[];
  comision?: number;
}

export interface PropertyFilters {
  search?: string;
  estado?: string;
  ciudad?: string;
  tipo_propiedad?: string;
  habitaciones?: number;
  banos?: number;
  precio_min?: number;
  precio_max?: number;
  area_min?: number;
  area_max?: number;
  transaccion?: string;
  fecha_desde?: string;
  fecha_hasta?: string;
}

export interface PropertyStats {
  totalProperties: number;
  averagePrice: number;
  propertyTypes: { [key: string]: number };
  cities: { [key: string]: number };
  priceRanges: { [key: string]: number };
}

export enum UserRole {
  ADMIN = 'admin',
  COMERCIAL = 'comercial',
  RESIDENCIAL = 'residencial',
  VENTAS = 'ventas',
  CALL_CENTER = 'call_center',
  ASESOR = 'asesor'
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  active: boolean;
  avatar?: string;
}

export interface AuthContextType {
  user: User | null;
  login: (email: string, password: string) => Promise<boolean>;
  logout: () => void;
  canEdit: boolean;
  canViewOwnerData: boolean;
  loading: boolean;
}